import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the HiddenScreenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-hidden-screen',
  templateUrl: 'hidden-screen.html',
})
export class HiddenScreenPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/hidden-screen/hidden-screen.ts